// Mobile menu toggle functionality
(function() {
  'use strict';

  // Wait for the DOM to be fully loaded
  document.addEventListener('DOMContentLoaded', function() {
    const giftScrollers = new WeakMap();

    function findScrollers(scope) {
      const scrollers = [];
      const add = (selector, viewportSelector, edgeTolerance, scrollThreshold) => {
        const roots = [];
        if (scope.matches?.(selector)) roots.push(scope);
        scope.querySelectorAll?.(selector).forEach((root) => roots.push(root));
        roots.forEach((root) => {
          const viewport = root.querySelector(viewportSelector);
          if (viewport) scrollers.push({ root, viewport, edgeTolerance, scrollThreshold });
        });
      };
      add('[data-gift-scroll]', '[data-gift-scroll-viewport]', 8, 2);
      add('[data-range-viewport]', '.mobile-menu-range-grid', 1, 1);
      return scrollers;
    }

    function initGiftScrollers(scope) {
      findScrollers(scope).forEach(({ root: scroller, viewport, edgeTolerance, scrollThreshold }) => {
        if (giftScrollers.has(scroller)) return;
        const previousButton = scroller.querySelector('[data-gift-scroll-button="previous"]');
        const nextButton = scroller.querySelector('[data-gift-scroll-button="next"]');

        if (scroller.matches?.('[data-gift-scroll]')) scroller.setAttribute('data-gift-scroll-ready', 'true');

        function updateScroller() {
          const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
          const isScrollable = maxScroll > scrollThreshold;
          scroller.classList.toggle('is-scrollable', isScrollable);
          scroller.classList.toggle('can-scroll-left', isScrollable && viewport.scrollLeft > edgeTolerance);
          scroller.classList.toggle('can-scroll-right', isScrollable && viewport.scrollLeft < maxScroll - edgeTolerance);
          if (previousButton) previousButton.disabled = !isScrollable || viewport.scrollLeft <= edgeTolerance;
          if (nextButton) nextButton.disabled = !isScrollable || viewport.scrollLeft >= maxScroll - edgeTolerance;
        }

        function moveScroller(direction) {
          viewport.scrollBy({
            left: direction * Math.max(180, viewport.clientWidth * 0.88),
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        }

        const previousHandler = () => moveScroller(-1);
        const nextHandler = () => moveScroller(1);
        const scrollOptions = { passive: true };
        previousButton?.addEventListener('click', previousHandler);
        nextButton?.addEventListener('click', nextHandler);
        viewport.addEventListener('scroll', updateScroller, scrollOptions);
        window.addEventListener('resize', updateScroller, scrollOptions);
        document.addEventListener('shown.bs.offcanvas', updateScroller);

        let observer;
        if ('ResizeObserver' in window) {
          observer = new ResizeObserver(updateScroller);
          observer.observe(viewport);
        }

        giftScrollers.set(scroller, () => {
          previousButton?.removeEventListener('click', previousHandler);
          nextButton?.removeEventListener('click', nextHandler);
          viewport.removeEventListener('scroll', updateScroller, scrollOptions);
          window.removeEventListener('resize', updateScroller, scrollOptions);
          document.removeEventListener('shown.bs.offcanvas', updateScroller);
          observer?.disconnect();
          if (scroller.matches?.('[data-gift-scroll]')) scroller.removeAttribute('data-gift-scroll-ready');
          giftScrollers.delete(scroller);
        });

        updateScroller();
      });
    }

    function unloadGiftScrollers(scope) {
      findScrollers(scope).forEach(({ root }) => giftScrollers.get(root)?.());
    }

    function initDesktopMegaMenus(scope) {
      scope.querySelectorAll('.mega-menu-item').forEach((menuItem) => {
        const trigger = menuItem.querySelector(':scope > .mega-menu-trigger');
        if (!trigger || trigger.dataset.megaMenuReady === 'true') return;

        trigger.dataset.megaMenuReady = 'true';
        const setExpanded = (expanded) => trigger.setAttribute('aria-expanded', String(expanded));

        menuItem.addEventListener('mouseenter', () => setExpanded(true));
        menuItem.addEventListener('mouseleave', () => {
          setExpanded(false);
          menuItem.classList.remove('mega-menu-item--dismissed');
        });
        menuItem.addEventListener('focusin', () => setExpanded(true));
        menuItem.addEventListener('focusout', () => {
          window.requestAnimationFrame(() => {
            if (!menuItem.contains(document.activeElement)) {
              setExpanded(false);
              menuItem.classList.remove('mega-menu-item--dismissed');
            }
          });
        });
        menuItem.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          event.preventDefault();
          menuItem.classList.add('mega-menu-item--dismissed');
          setExpanded(false);
          trigger.focus({ preventScroll: true });
        });
      });
    }

    initGiftScrollers(document);
    initDesktopMegaMenus(document);

    document.addEventListener('shopify:section:load', (event) => {
      initGiftScrollers(event.target);
      initDesktopMegaMenus(event.target);
    });
    document.addEventListener('shopify:section:unload', (event) => unloadGiftScrollers(event.target));

    const offcanvasMenu = document.getElementById('offcanvas-menu');
    const menuToggle = document.querySelector('[data-bs-target="#offcanvas-menu"]');
    
    if (!offcanvasMenu || !menuToggle) return;

    // Get the offcanvas instance
    new bootstrap.Offcanvas(offcanvasMenu);
    
    // Toggle menu state
    function updateMenuState(isOpen) {
      if (isOpen) {
        menuToggle.classList.add('show');
        document.body.classList.add('menu-open');
      } else {
        menuToggle.classList.remove('show');
        document.body.classList.remove('menu-open');
      }
    }

    const menuViews = Array.from(offcanvasMenu.querySelectorAll('[data-mobile-menu-view]'));
    const rootView = offcanvasMenu.querySelector('[data-mobile-menu-view="root"]');
    let lastViewTrigger = null;

    function showMenuView(viewName, shouldFocus) {
      const nextView = offcanvasMenu.querySelector(`[data-mobile-menu-view="${viewName}"]`);
      if (!nextView) return;

      menuViews.forEach((view) => {
        const isCurrent = view === nextView;
        view.hidden = !isCurrent;
        view.classList.toggle('is-active', isCurrent);
      });

      offcanvasMenu.querySelectorAll('[data-mobile-menu-open]').forEach((trigger) => {
        trigger.setAttribute('aria-expanded', String(trigger.dataset.mobileMenuOpen === viewName));
      });

      offcanvasMenu.querySelector('.offcanvas-body')?.scrollTo({ top: 0, behavior: 'auto' });

      if (shouldFocus) {
        window.requestAnimationFrame(() => {
          nextView.querySelector('[data-mobile-menu-back]')?.focus();
        });
      }
    }

    offcanvasMenu.querySelectorAll('[data-mobile-menu-open]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        lastViewTrigger = trigger;
        showMenuView(trigger.dataset.mobileMenuOpen, true);
      });
    });

    offcanvasMenu.querySelectorAll('[data-mobile-menu-back]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        showMenuView('root', false);
        window.requestAnimationFrame(() => lastViewTrigger?.focus());
      });
    });
    
    // Handle menu show/hide events
    offcanvasMenu.addEventListener('show.bs.offcanvas', function() {
      updateMenuState(true);
    });
    
    offcanvasMenu.addEventListener('hidden.bs.offcanvas', function() {
      updateMenuState(false);
      if (rootView) showMenuView('root', false);
      lastViewTrigger = null;
    });
    
    // Handle initial state
    updateMenuState(offcanvasMenu.classList.contains('show'));
  });
})();
